import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import { GRI_STANDARDS } from "data/standards/griStandards";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { IRIS_COMPLIANCE_CUSTOM_FORM } from "data/forms/griFormSchema";
import { irisPrincipleReportItems } from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import { useNavigate } from "react-router-dom";
import IRISIntroComponent from "components/customizedStandardsComponent/IRISIntroComponent";

const IRISSystemKpiProjEntities = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const navigate = useNavigate();

  const steps = ["Select GRI Standards" /* ... other steps commented out ... */];

  useEffect(() => {
    if (activeStep === 4 && prevStep === 3) {
      setShowReviewPopup(true);
    }
  }, [activeStep, prevStep]);

  const handleSkipToDashboard = () => {
    setShowReviewPopup(false);
    navigate("/");
  };

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    // Most safe & predictable behavior:
    // On step 0 → go back to parent section or dashboard
    if (activeStep === 0) {
      navigate("/reporting/iris/iris-giin-compliance-matrix", { replace: true });
      return;
    }

    // Normal wizard navigation for later steps
    setActiveStep((prev) => Math.max(0, prev - 1));
  };

  const handleClosePopup = () => setShowReviewPopup(false);

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <IRISIntroComponent onNext={handleNext} onPrevious={handleBack} />;
      // ... other cases remain commented out ...
      default:
        return <Typography>Unknown step</Typography>;
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <NavigationButtons
              imageKey="IRIS+ (GIIN)"
              title="IRIS GIIN Reporting"
              activeStep={activeStep}
              onBack={handleBack}
              // You can also pass showBack={activeStep > 0} if you want to
              // conditionally hide the back button on step 0
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        {/* Progress dots */}
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "center", mt: -1 }}>
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToDashboard}
      />
    </>
  );
};

export default IRISSystemKpiProjEntities;